import { websitePublicConfig } from '@/config/website-public';
import { Routes } from '@/routes';

export const ACCOUNT_SETTINGS_QUERY_PARAM = 'accountSettings';

export type AccountSettingsSection =
  | 'credits'
  | 'billing'
  | 'profile'
  | 'security';

export function resolveAccountSettingsSection(
  section: AccountSettingsSection,
  creditsEnabled = websitePublicConfig.credits.enableCredits
): AccountSettingsSection {
  return section === 'credits' && !creditsEnabled ? 'billing' : section;
}

export function parseAccountSettingsSection(
  value: string | null | undefined
): AccountSettingsSection | null {
  if (
    value === 'credits' ||
    value === 'billing' ||
    value === 'profile' ||
    value === 'security'
  ) {
    return resolveAccountSettingsSection(value);
  }

  return null;
}

export function resolveAccountSettingsSectionFromSearchParams(
  searchParams: Pick<URLSearchParams, 'get'>
) {
  return parseAccountSettingsSection(
    searchParams.get(ACCOUNT_SETTINGS_QUERY_PARAM)
  );
}

export function buildAccountSettingsHref(
  section: AccountSettingsSection,
  options: { source?: string } = {}
) {
  const searchParams = new URLSearchParams({
    [ACCOUNT_SETTINGS_QUERY_PARAM]: resolveAccountSettingsSection(section),
  });
  if (options.source) {
    searchParams.set('source', options.source);
  }

  return `${Routes.Root}?${searchParams.toString()}`;
}

export function removeAccountSettingsIntentFromHref(href: string) {
  const url = new URL(href, 'https://account-settings.local');
  url.searchParams.delete(ACCOUNT_SETTINGS_QUERY_PARAM);
  return `${url.pathname}${url.search}${url.hash}`;
}
